import { settings as raySettings } from '@wework/ray-core';
import debounce from 'lodash/debounce';

export default class PictureTooltip {
  constructor() {
    this.tolltipList = document.querySelectorAll('.tooltip-box');
    this.imageWrapper = document.querySelector('.health-and-safety-measure__image-wrapper');
    this.desktopPoints = [];
    this.devicePoints = [];
    this.corectionPointForDevices = 6;
    // Break width on steps
    this.breakPointStep = 30;
    // Device sizes
    this.mobileImageSize = 490;
    this.desktopImageSize = 760;
    this.tabletImageSize = 1090;

    this.deviceBreakpoints = raySettings.breakpointsInPixels;

    this.initBreakPoints();
    this.updateTooltipsImage();
    window.addEventListener('resize', debounce(this.updateTooltipsImage, 150));
  }

  updateTooltipsImage = () => {
    if (this.imageWrapper) {
      const width = this.imageWrapper.offsetWidth;
      if (width > this.desktopImageSize) {
        this.desktopPoints.forEach((item, idx) => {
          if (this.desktopPoints[idx] <= width && width <= this.desktopPoints[idx - 1]) {
            this.setTootipPosition((idx - 1) / 2 - this.corectionPointForDevices);
          }
        });
      } else {
        this.devicePoints.forEach((item, idx) => {
          if (this.devicePoints[idx] <= width && width <= this.devicePoints[idx - 1]) {
            this.setTootipPosition(idx - 1);
          }
        });
      }
    }
  };

  setTootipPosition = ratio => {
    this.tolltipList.forEach(tooltip => {
      const [left] = tooltip.dataset.position.split(';');
      tooltip.style.left = `${Number(left) - ratio}%`; // eslint-disable-line no-param-reassign
    });
  };

  initBreakPoints = () => {
    for (let i = this.desktopImageSize; i >= this.mobileImageSize; i -= this.breakPointStep) {
      this.devicePoints.push(i);
    }

    for (let i = this.tabletImageSize; i >= this.desktopImageSize; i -= this.breakPointStep) {
      this.desktopPoints.push(i);
    }
  };

  static setUp(options) {
    return new PictureTooltip(options);
  }
}
